import { createAction } from 'redux-actions';

const simplePayloadCreator = p => p;

export const selectActivityAction = createAction('SELECT_ACTIVITY', simplePayloadCreator);

export const selectActivity = ({ activity }) => (dispatch) => {
  dispatch(selectActivityAction({ activity }));
};
